export const isClient = typeof window !== "undefined"

export function getCookieValue(name: string) {
  if (!isClient) {
    return null
  }

  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  return parts.length === 2 ? (parts.pop()?.split(";").shift() ?? null) : null
}

export function removeCookie(name: string, path: string, domain: string) {
  if (typeof window === "undefined") {
    return null
  }

  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path}; domain=${domain};`
}
